import React from 'react'
import PropTypes from 'prop-types'

import { OVERLAY } from 'components/AuthModal/styles'
import CloseIcon from 'components/CloseIcon'
import { default as DefaultModal } from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'

const ProfileDataModal = ({ show, profile, onClose }) => {
  if (!profile) return null

  return (
    <Overlay
      show={show}
      className={OVERLAY}
      preventEscBackdropClose={true}
      onClose={() => onClose()}
    >
      <DefaultModal innerClassName="overflow-y-scroll flex flex-col justify-center px-5">
        <div className="relative h-auto max-h-screen flex flex-col text-white w-full rounded-xl px-5 py-6 bg-woodsmokeBlackDarker md:w-auto md:min-w-96 md:max-w-4xl">
          <div className="w-full flex justify-between items-center mb-6">
            <div className="text-lg">{profile.fullName} - Profile Data</div>
            <button
              className="bg-white bg-opacity-20 w-5 h-5 rounded-full flex items-center justify-center"
              onClick={() => onClose()}
            >
              <CloseIcon className="w-2 h-2 text-white" />
            </button>
          </div>
          {profile.summary && (
            <div className="mb-4">
              <h3 className="text-sm font-semibold text-gray-400 mb-2">Summary</h3>
              <p className="text-sm text-gray-200">{profile.summary}</p>
            </div>
          )}
          {profile.profile && (
            <div className="mb-4">
              <h3 className="text-sm font-semibold text-gray-400 mb-2">Profile</h3>
              <p className="text-sm text-gray-200 whitespace-pre-wrap">{profile.profile}</p>
            </div>
          )}
          {profile.data && (
            <div>
              <h3 className="text-sm font-semibold text-gray-400 mb-2">Raw Data</h3>
              <div className="bg-gray-800 rounded-lg p-4 overflow-auto max-h-96">
                <pre className="text-sm text-gray-200 whitespace-pre-wrap">
                  {JSON.stringify(profile.data, null, 2)}
                </pre>
              </div>
            </div>
          )}
        </div>
      </DefaultModal>
    </Overlay>
  )
}

ProfileDataModal.propTypes = {
  show: PropTypes.bool,
  profile: PropTypes.object,
  onClose: PropTypes.func.isRequired,
}

export default ProfileDataModal
